export default __webpack_public_path__ + "static/media/netvrk-v2-6.3d51dee7.jpg";